var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { class: "spinner spinner-align-" + _vm.localAlign }, [
    !_vm.editingFieldLabel
      ? _c(
          "label",
          {
            attrs: { for: "spinner-input" },
            on: { click: _vm.focusFieldLabel },
          },
          [_vm._v(_vm._s(_vm.displayFieldLabel))]
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.editingFieldLabel
      ? _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.localFieldLabel,
              expression: "localFieldLabel",
            },
          ],
          ref: "fieldLabelInput",
          staticClass: "field-label-input",
          attrs: { type: "text", placeholder: "Bir sayı girin" },
          domProps: { value: _vm.localFieldLabel },
          on: {
            blur: _vm.stopEditingFieldLabel,
            keydown: function ($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
              ) {
                return null
              }
              return _vm.stopEditingFieldLabel.apply(null, arguments)
            },
            input: function ($event) {
              if ($event.target.composing) {
                return
              }
              _vm.localFieldLabel = $event.target.value
            },
          },
        })
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "input-wrapper" }, [
      _c("div", { staticClass: "spinner-wrapper" }, [
        _c(
          "button",
          {
            staticClass: "spinner-button decrement",
            attrs: { type: "button" },
            on: { click: _vm.decrement },
          },
          [
            _c(
              "svg",
              {
                attrs: {
                  xmlns: "http://www.w3.org/2000/svg",
                  viewBox: "0 0 24 24",
                  fill: "none",
                  stroke: "currentColor",
                  "stroke-width": "2",
                },
              },
              [_c("line", { attrs: { x1: "5", y1: "12", x2: "19", y2: "12" } })]
            ),
          ]
        ),
        _vm._v(" "),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.spinnerValue,
              expression: "spinnerValue",
            },
          ],
          attrs: { type: "number", id: "spinner-input", min: "0" },
          domProps: { value: _vm.spinnerValue },
          on: {
            input: [
              function ($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.spinnerValue = $event.target.value
              },
              _vm.updateField,
            ],
            focus: _vm.onFocus,
            blur: _vm.onBlur,
          },
        }),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "spinner-button increment",
            attrs: { type: "button" },
            on: { click: _vm.increment },
          },
          [
            _c(
              "svg",
              {
                attrs: {
                  xmlns: "http://www.w3.org/2000/svg",
                  viewBox: "0 0 24 24",
                  fill: "none",
                  stroke: "currentColor",
                  "stroke-width": "2",
                },
              },
              [
                _c("line", {
                  attrs: { x1: "12", y1: "5", x2: "12", y2: "19" },
                }),
                _vm._v(" "),
                _c("line", {
                  attrs: { x1: "5", y1: "12", x2: "19", y2: "12" },
                }),
              ]
            ),
          ]
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }